import { getHardwareConcurrencyWithMemory } from '@/utils/system';

import { ThumbnailGenerator } from './ThumbnailGenerator';
import { ThumbnailGeneratorFallback } from './ThumbnailGeneratorFallback';

/**
 * ThumbnailGenerator 객체를 생성합니다.
 *
 * 기기 성능에 따라서, worker 사용 여부를 결정합니다.
 *
 * # 사용법
 *
 * ## 단일 함수 방식
 * ```ts
  const generator = createThumbnailGenerator(1);

  try {
    const result = await generator.enqueue(sourceImage, params);

    return {
      file: await convertObjectUrlToFile({ ...result, baseName }),
      width: result.width,
      height: result.height,
      mimeType: result.mimeType,
    };
  } finally {
    await generator.dispose();
  }
 * ```
 */
export const createThumbnailGenerator = (concurrency?: number) => {
  const hardwareConcurrency = getHardwareConcurrencyWithMemory();

  /**
   * ###
   * - 559장 기준
   * - M1 Pro 10코어 기준 : 15초.
   * - (Fallback) Ryzen 5 3400G : 61 초
   * - Ryzen 5 3400G : 2분 이상
   */
  return hardwareConcurrency <= 2
    ? new ThumbnailGeneratorFallback(concurrency ?? hardwareConcurrency)
    : new ThumbnailGenerator(concurrency ?? hardwareConcurrency);
};
